/* Builder Kit — Components-only flow (Sennbeauty) */
(function () {
  const root = document.getElementById('builder-kit');
  if (!root) return;

  // -------- Kit type detection (Liquid hint or URL fallback) --------
  const hinted = (root.dataset.kitType || '').toLowerCase().trim();
  const path = ((window.location && window.location.pathname) || '').toLowerCase();
  const inferred =
    path.includes('base-starter-kit') ? 'base' :
    path.includes('ultimate-starter-kit') ? 'ultimate' :
    '';
  const KIT_TYPE = hinted || inferred || 'ultimate';

  // ---------- Canonical IDs/handles ----------
  // Ultimate = Oil (first) then Lamp (fallback only; Liquid supplies actual ids)
  const ULTIMATE_IDS = ['46009669157029', '46009673777317']; // [Oil, Lamp] (fallback only)
  const ULTIMATE_HANDLES = [
    '/products/senn-beauty-nourishing-cuticle-oil',
    '/products/ultimate-senn-beauty-led-lamp'
  ];

  // Base = Lamp only (fallback only)
  const BASE_IDS = ['46009673777317'];
  const BASE_HANDLES = ['/products/base-senn-beauty-led-lamp'];

  // ----- Config from data attributes -----
  const MIN = Number(root.dataset.minItems || 1);
  const MAX = Number(root.dataset.maxItems || MIN);
  const KIT_TITLE = root.dataset.kitTitle || 'Starter Kit';
  const KIT_PROP_LABEL = root.dataset.kitPropLabel || 'Bundle';

  // Per-kit target prices (left intact; not used by pricing)
  const DEFAULT_ULTIMATE_CENTS = 9900;
  const DEFAULT_BASE_CENTS = 4499;

  const KIT_PRICE_ULTIMATE_CENTS = root.dataset.kitPriceUltimate
    ? Math.round(Number(root.dataset.kitPriceUltimate) * 100)
    : (root.dataset.kitPrice ? Math.round(Number(root.dataset.kitPrice) * 100) : DEFAULT_ULTIMATE_CENTS);

  const KIT_PRICE_BASE_CENTS = root.dataset.kitPriceBase
    ? Math.round(Number(root.dataset.kitPriceBase) * 100)
    : DEFAULT_BASE_CENTS;

  const SUBTOTAL_INCLUDES_INCLUDED =
    (root.dataset.subtotalIncludesIncluded || 'true') === 'true';
  const LOCK_PREINCLUDED = (root.dataset.lockPreincluded || 'true') === 'true';

  // Parse dataset values from Liquid
  const rawIds = (root.dataset.preincludedVariants || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  const rawHandles = (root.dataset.includedHandles || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  // ---------- Robust fallback + enforcement ----------
  let PREINCLUDED_IDS, INCLUDED_HANDLES;

  if (KIT_TYPE === 'base') {
    PREINCLUDED_IDS = rawIds.length ? rawIds.slice() : BASE_IDS.slice();
    INCLUDED_HANDLES =
      rawHandles.length === PREINCLUDED_IDS.length
        ? rawHandles.slice()
        : BASE_HANDLES.slice(0, PREINCLUDED_IDS.length);
  } else {
    PREINCLUDED_IDS = rawIds.length ? rawIds.slice() : ULTIMATE_IDS.slice();
    INCLUDED_HANDLES =
      rawHandles.length === PREINCLUDED_IDS.length
        ? rawHandles.slice()
        : ULTIMATE_HANDLES.slice(0, PREINCLUDED_IDS.length);
  }

  const CURRENCY =
    root.dataset.currency ||
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    'AUD';

  // ----- DOM refs -----
  const summaryList = root.querySelector('.builder-kit__summary-list');
  const subtotalEl = root.querySelector('.builder-kit__subtotal');
  const savingsWrap = root.querySelector('.builder-kit__savings');
  const savingsEl = root.querySelector('.builder-kit__savings-amount');
  const submitBtns = root.querySelectorAll('.builder-kit__submit, .builder-kit__submit--mobile');
  const mobileSticky = root.querySelector('.builder-kit__mobile-sticky');
  const barFill = root.querySelector('.builder-kit__bar-fill');
  const countEls = root.querySelectorAll('.builder-kit__count');
  const maxEls = root.querySelectorAll('.builder-kit__max');
  maxEls.forEach((el) => (el.textContent = String(MAX)));

  // ----- Bottom bar DOM refs -----
  const bottomBar = document.getElementById('builder-kit-bottom-bar');
  const bottomBarItems = document.getElementById('builder-kit-bar-items');
  const bottomBarTotal = document.getElementById('builder-kit-bar-total');
  const bottomBarSavings = document.getElementById('builder-kit-bar-savings');

  // ----- State -----
  // included: Map<variantId, {id, productTitle, variantTitle, image, price, compareAt, type:'included'}>
  // selected: Map<variantId, {id, productTitle, variantTitle, image, price, compareAt, type:'nail', quantity}>
  const included = new Map();
  const selected = new Map();

  // Lock set for preincluded IDs
  const lockedVariantSet = new Set(PREINCLUDED_IDS.map(String));

  // ----- Utilities -----
  const money = (cents) =>
    (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency: CURRENCY });

  const normalizeImg = (src) => (!src ? '' : src.startsWith('//') ? 'https:' + src : src);

  // Escape any string before interpolating into innerHTML. Product titles,
  // variant titles and image URLs come from Shopify's JSON APIs and are not
  // guaranteed to be HTML-safe.
  const escapeHtml = (s) =>
    String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  // Truncate long product names for the bar labels. Hoisted so it isn't
  // redefined on every render.
  function shortName(title) {
    let short = (title || '')
      .replace(/^Semi[- ]Cured Gel Nail Wraps?\s*/i, '')
      .replace(/^Senn Beauty\s*/i, '')
      .replace(/^Ultimate\s*/i, '')
      .replace(/^Base\s*/i, '')
      .replace(/\bNourishing\b/i, '')
      .trim();
    if (!short) short = title || '';
    return short;
  }

  function getSelectedNailCount() {
    let count = 0;
    selected.forEach((v) => {
      count += Number(v.quantity || 0);
    });
    return count;
  }

  function getCardMeta(card) {
    const productTitle =
      card.getAttribute('data-title') ||
      (card.querySelector('.builder-kit__product-title')?.textContent || '').trim();

    const img = card.querySelector('.builder-kit__img');
    const rawImage = img?.getAttribute('src') || img?.getAttribute('data-src') || '';
    const image = normalizeImg(rawImage);

    const variantEl = card.querySelector('.builder-kit__variant');
    const btn = card.querySelector('.builder-kit__add');

    let variantId = '';
    let variantTitle = '';
    let price = 0;
    let compareAt = 0;

    if (variantEl) {
      if (variantEl.tagName === 'SELECT') {
        const opt = variantEl.selectedOptions && variantEl.selectedOptions[0];
        if (opt) {
          variantId = opt.value;
          variantTitle = (opt.textContent || '').trim();
          if (opt.dataset.price) price = Number(opt.dataset.price);
          compareAt =
            Number(opt.dataset.compareAt || 0) ||
            Number(opt.dataset.compareAtPrice || 0) ||
            Number(opt.dataset.compare_at_price || 0) ||
            0;
        }
      } else {
        variantId = (variantEl.value || '').trim();
        if (btn?.dataset?.price) price = Number(btn.dataset.price);
        compareAt =
          Number(btn?.dataset?.compareAt || 0) ||
          Number(btn?.dataset?.compareAtPrice || 0) ||
          Number(btn?.dataset?.compare_at_price || 0) ||
          0;
      }
    }

    if (!variantId && btn?.dataset?.variantId) variantId = btn.dataset.variantId;

    return { productTitle, variantId, variantTitle, price, compareAt, image, variantEl, btn };
  }

  function indexGridByVariantId() {
    const map = new Map();
    root.querySelectorAll('.builder-kit__card').forEach((card) => {
      const meta = getCardMeta(card);
      if (meta.variantId) map.set(String(meta.variantId), { card, ...meta });
    });
    return map;
  }

  async function fetchProductByHandle(handle) {
    const clean = handle.replace('/products/', '').replace(/^\/+|\/+$/g, '');
    try {
      const res = await fetch(`/products/${clean}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  async function fetchVariantPricing(id) {
    try {
      const res = await fetch(`/variants/${id}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return { price: 0, compareAt: 0 };
      const data = await res.json();
      return {
        price: Number(data?.price || 0),
        compareAt: Number(data?.compare_at_price || 0),
      };
    } catch {
      return { price: 0, compareAt: 0 };
    }
  }

  async function hydrateIncluded() {
    if (!PREINCLUDED_IDS.length) return;

    const pairs = PREINCLUDED_IDS.map((id, i) => ({
      id: String(id),
      handle: INCLUDED_HANDLES[i] ? INCLUDED_HANDLES[i].replace('/products/', '') : null,
    }));

    const gridIndex = indexGridByVariantId();

    const handleMeta = {};
    await Promise.all(
      pairs
        .filter((p) => p.handle)
        .map(async (p) => {
          if (handleMeta[p.handle]) return;
          const prod = await fetchProductByHandle(p.handle);
          if (prod) {
            const img = (prod.images && prod.images[0]) || prod.featured_image || '';
            handleMeta[p.handle] = { title: prod.title, image: normalizeImg(img) };
          }
        })
    );

    for (const p of pairs) {
      const fromGrid = gridIndex.get(p.id);

      let productTitle =
        fromGrid?.productTitle || (p.handle && handleMeta[p.handle]?.title) || 'Included item';
      let variantTitle = fromGrid?.variantTitle || '';
      let image = fromGrid?.image || (p.handle && handleMeta[p.handle]?.image) || '';
      image = normalizeImg(image);

      let price = Number(fromGrid?.price || 0);
      let compareAt = Number(fromGrid?.compareAt || 0);

      if (price === 0) {
        const pricing = await fetchVariantPricing(p.id);
        price = pricing.price;
        compareAt = pricing.compareAt;
      }

      included.set(p.id, {
        id: Number(p.id),
        productTitle,
        variantTitle,
        image,
        price,
        compareAt,
        type: 'included',
      });
    }
  }

  // ---------- Pricing engine ----------
  function computeTotals() {
    let nailsTotal = 0;
    let includedTotal = 0;
    let retailTotal = 0;

    // Selected nails (quantity-aware)
    selected.forEach((v) => {
      const qty = Number(v.quantity || 0);
      const price = Number(v.price || 0);
      const compareAt = Number(v.compareAt || v.price || 0);
      nailsTotal += price * qty;
      retailTotal += compareAt * qty;
    });

    // Included items
    included.forEach((v) => {
      const price = Number(v.price || 0);
      const compareAt = Number(v.compareAt || v.price || 0);
      includedTotal += price;
      retailTotal += compareAt;
    });

    const subtotal = SUBTOTAL_INCLUDES_INCLUDED ? (nailsTotal + includedTotal) : nailsTotal;
    const savings = Math.max(0, retailTotal - subtotal);

    return {
      thresholdReached: getSelectedNailCount() >= MIN,
      subtotal,
      savings,
      includedEffective: Array.from(included.values()).map((v) => ({
        id: v.id,
        retail: Number(v.compareAt || v.price || 0),
        final: Number(v.price || 0),
      })),
    };
  }

  // ---------- Render ----------
  function renderSummaryRows(pricePlan) {
    if (!summaryList) return;
    summaryList.innerHTML = '';

    // Included first
    if (included.size) {
      const effectiveMap = new Map(pricePlan.includedEffective.map((p) => [String(p.id), p]));
      included.forEach((v) => {
        const eff = effectiveMap.get(String(v.id)) || { retail: v.compareAt || v.price, final: v.price };
        const hasSlash = eff.final < eff.retail;

        const li = document.createElement('li');
        li.className = 'builder-kit__summary-item builder-kit__summary-item--included';

        const imgHTML = v.image
          ? `<img class="builder-kit__thumb" src="${escapeHtml(v.image)}" alt="${escapeHtml(v.productTitle)}">`
          : '';
        const titlePart = v.variantTitle ? ' — ' + escapeHtml(v.variantTitle) : '';

        let priceHTML = '';
        if (eff.final === 0) {
          priceHTML = hasSlash
            ? `<span class="price price--compare">${money(eff.retail)}</span><span class="price price--final">FREE</span>`
            : `<span class="price price--final">FREE</span>`;
        } else {
          priceHTML = hasSlash
            ? `<span class="price price--compare">${money(eff.retail)}</span><span class="price price--final">${money(eff.final)}</span>`
            : `<span class="price">${money(eff.retail)}</span>`;
        }

        li.innerHTML = `
          <span class="label">
            ${imgHTML}
            <span class="t">${escapeHtml(v.productTitle)}${titlePart} <em>(Included)</em></span>
          </span>
          <span class="value">${priceHTML}</span>
        `;
        summaryList.appendChild(li);
      });

      const sep = document.createElement('li');
      sep.className = 'builder-kit__summary-sep';
      sep.innerHTML = '<hr />';
      summaryList.appendChild(sep);
    }

    // Selected nails (quantity-aware + decrement remove)
    selected.forEach((v) => {
      const li = document.createElement('li');
      li.className = 'builder-kit__summary-item';

      const imgHTML = v.image
        ? `<img class="builder-kit__thumb" src="${escapeHtml(v.image)}" alt="${escapeHtml(v.productTitle)}">`
        : '';
      const titlePart = v.variantTitle ? ' — ' + escapeHtml(v.variantTitle) : '';
      const qtyLabel = v.quantity > 1 ? ` ×${Number(v.quantity)}` : '';
      const linePrice = Number(v.price || 0) * Number(v.quantity || 0);

      li.innerHTML = `
        <span class="label">
          ${imgHTML}
          <span class="t">${escapeHtml(v.productTitle)}${titlePart}${qtyLabel}</span>
        </span>
        <span class="value">
          <span class="price">${money(linePrice)}</span>
          <button class="builder-kit__remove btn btn--secondary" type="button" data-variant="${escapeHtml(v.id)}">Remove</button>
        </span>
      `;
      summaryList.appendChild(li);
    });
  }

  // ---------- Bottom Bar Render ----------
  function renderBottomBar(pricePlan) {
    if (!bottomBar || !bottomBarItems) return;

    bottomBarItems.innerHTML = '';
    const count = getSelectedNailCount();

    // Show bar as soon as there are included items (always on init)
    const hasContent = included.size > 0 || selected.size > 0;
    bottomBar.classList.toggle('is-visible', hasContent);

    // Render included items as thumbnails
    included.forEach((v) => {
      const wrap = document.createElement('div');
      wrap.className = 'builder-kit__bar-item-wrap';

      const thumb = document.createElement('div');
      thumb.className = 'builder-kit__bar-item builder-kit__bar-item--included';
      if (v.image) {
        const img = document.createElement('img');
        img.src = v.image;
        img.alt = v.productTitle || '';
        thumb.appendChild(img);
      }
      wrap.appendChild(thumb);

      const label = document.createElement('span');
      label.className = 'builder-kit__bar-item-label';
      label.textContent = shortName(v.productTitle);
      wrap.appendChild(label);

      const sublabel = document.createElement('span');
      sublabel.className = 'builder-kit__bar-item-label builder-kit__bar-item-label--sub';
      sublabel.textContent = 'Included';
      wrap.appendChild(sublabel);

      bottomBarItems.appendChild(wrap);
    });

    // Separator between included and nail slots
    if (included.size > 0) {
      const sep = document.createElement('div');
      sep.className = 'builder-kit__bar-sep';
      bottomBarItems.appendChild(sep);
    }

    // Render selected nails as thumbnails
    selected.forEach((v) => {
      const qty = Number(v.quantity || 1);
      for (let i = 0; i < qty; i++) {
        const wrap = document.createElement('div');
        wrap.className = 'builder-kit__bar-item-wrap';

        const thumb = document.createElement('div');
        thumb.className = 'builder-kit__bar-item builder-kit__bar-item--nail';
        if (v.image) {
          const img = document.createElement('img');
          img.src = v.image;
          img.alt = v.productTitle || '';
          thumb.appendChild(img);
        }

        // Add remove button
        const removeBtn = document.createElement('button');
        removeBtn.className = 'builder-kit__bar-item-remove';
        removeBtn.type = 'button';
        removeBtn.dataset.variant = String(v.id);
        removeBtn.textContent = '\u00D7'; // ×
        removeBtn.setAttribute('aria-label', 'Remove ' + (v.productTitle || ''));
        thumb.appendChild(removeBtn);

        wrap.appendChild(thumb);

        const label = document.createElement('span');
        label.className = 'builder-kit__bar-item-label';
        label.textContent = shortName(v.productTitle);
        wrap.appendChild(label);

        bottomBarItems.appendChild(wrap);
      }
    });

    // Render empty slots for remaining selections needed
    const remaining = MAX - count;
    for (let i = 0; i < remaining; i++) {
      const wrap = document.createElement('div');
      wrap.className = 'builder-kit__bar-item-wrap';

      const slot = document.createElement('div');
      slot.className = 'builder-kit__bar-slot-empty';
      slot.textContent = '+';
      wrap.appendChild(slot);

      const label = document.createElement('span');
      label.className = 'builder-kit__bar-item-label';
      label.textContent = 'Choose';
      wrap.appendChild(label);

      bottomBarItems.appendChild(wrap);
    }

    // Update total price
    if (bottomBarTotal) {
      bottomBarTotal.textContent = money(pricePlan.subtotal);
    }

    // Update savings
    if (bottomBarSavings) {
      if (pricePlan.savings > 0) {
        bottomBarSavings.textContent = 'You save ' + money(pricePlan.savings);
        bottomBarSavings.style.display = '';
      } else {
        bottomBarSavings.textContent = '';
        bottomBarSavings.style.display = 'none';
      }
    }
  }

  function refreshGridButtons() {
    const count = getSelectedNailCount();

    root.querySelectorAll('.builder-kit__card').forEach((card) => {
      const { variantId, variantEl, btn } = getCardMeta(card);
      if (!btn || !variantEl) return;

      const key = String(variantId || '');
      const isLocked = LOCK_PREINCLUDED && lockedVariantSet.has(key);

      card.classList.toggle('is-locked', isLocked);

      if (isLocked) {
        btn.disabled = true;
        const addSpan = btn.querySelector('.builder-kit__add-text');
        const addedSpan = btn.querySelector('.builder-kit__added-text');
        if (addSpan) addSpan.textContent = 'Included';
        if (addedSpan) addedSpan.hidden = true;
        if (variantEl.tagName === 'SELECT') variantEl.disabled = true;
        return;
      }

      const isSelected = key && selected.has(key);
      btn.classList.toggle('is-added', !!isSelected);

      const addSpan = btn.querySelector('.builder-kit__add-text');
      const addedSpan = btn.querySelector('.builder-kit__added-text');
      if (addSpan) addSpan.hidden = !!isSelected;
      if (addedSpan) addedSpan.hidden = !isSelected;

      // Disable unselected cards when at max
      btn.disabled = !isSelected && count >= MAX;
    });
  }

  function refreshProgress(pricePlan) {
    const count = getSelectedNailCount();
    countEls.forEach((el) => (el.textContent = String(count)));

    if (barFill) {
      const pct = Math.min(100, Math.round((count / MAX) * 100));
      barFill.style.width = `${pct}%`;
    }

    // Proceed stays disabled until MIN nails selected (by quantity)
    const canSubmit = count >= MIN;

    submitBtns.forEach((b) => {
      b.disabled = !canSubmit;
      b.setAttribute('aria-disabled', (!canSubmit).toString());
      // Visual disable (some themes don't style :disabled) — see
      // .is-disabled rules in builder-kit.css.
      b.classList.toggle('is-disabled', !canSubmit);
    });

    if (mobileSticky) mobileSticky.hidden = count === 0;

    if (subtotalEl) subtotalEl.textContent = money(pricePlan.subtotal);

    if (savingsWrap && savingsEl) {
      if (pricePlan.savings > 0) {
        savingsEl.textContent = `-${money(pricePlan.savings)}`;
        savingsWrap.hidden = false;
      } else {
        savingsWrap.hidden = true;
      }
    }
  }

  function renderAll() {
    const pricePlan = computeTotals();
    renderSummaryRows(pricePlan);
    renderBottomBar(pricePlan);
    refreshGridButtons();
    refreshProgress(pricePlan);
  }

  // ------- Selection -------
  function toggleCard(card) {
    const meta = getCardMeta(card);
    if (!meta.variantId) return;

    const key = String(meta.variantId);

    // Block locked items (lamp/oil)
    if (LOCK_PREINCLUDED && lockedVariantSet.has(key)) {
      card.querySelector('.builder-kit__add')?.classList.add('kit-limit');
      setTimeout(() => card.querySelector('.builder-kit__add')?.classList.remove('kit-limit'), 300);
      return;
    }

    const existing = selected.get(key);

    if (existing) {
      // Increment quantity, but don't exceed MAX total nails
      if (getSelectedNailCount() >= MAX) {
        card.querySelector('.builder-kit__add')?.classList.add('kit-limit');
        setTimeout(() => card.querySelector('.builder-kit__add')?.classList.remove('kit-limit'), 300);
        return;
      }
      existing.quantity += 1;
    } else {
      if (getSelectedNailCount() >= MAX) {
        card.querySelector('.builder-kit__add')?.classList.add('kit-limit');
        setTimeout(() => card.querySelector('.builder-kit__add')?.classList.remove('kit-limit'), 300);
        return;
      }

      selected.set(key, {
        id: Number(meta.variantId),
        productTitle: meta.productTitle,
        variantTitle: meta.variantTitle,
        price: Number(meta.price || 0),
        compareAt: Number(meta.compareAt || 0),
        image: meta.image,
        type: 'nail',
        quantity: 1,
      });
    }

    renderAll();
  }

  function changeVariantOnSelectedCard(selectEl) {
    const card = selectEl.closest('.builder-kit__card');
    if (!card) return;

    const meta = getCardMeta(card);
    if (!meta.variantId) return;

    const key = String(meta.variantId);

    if (LOCK_PREINCLUDED && lockedVariantSet.has(key)) {
      selectEl.value = key;
      selectEl.classList.add('kit-limit');
      setTimeout(() => selectEl.classList.remove('kit-limit'), 300);
      return;
    }

    const isAdded = card.querySelector('.builder-kit__add')?.classList.contains('is-added');
    if (isAdded) {
      // If the card was already added, carry quantity across variant change for that product title
      let qtyCarry = 0;
      selected.forEach((v, k) => {
        if (v.productTitle === meta.productTitle) {
          qtyCarry += Number(v.quantity || 0);
          selected.delete(k);
        }
      });

      selected.set(key, {
        id: Number(meta.variantId),
        productTitle: meta.productTitle,
        variantTitle: meta.variantTitle,
        price: Number(meta.price || 0),
        compareAt: Number(meta.compareAt || 0),
        image: meta.image,
        type: 'nail',
        quantity: Math.max(1, qtyCarry || 1),
      });

      // If carrying qty pushes over MAX, clamp
      while (getSelectedNailCount() > MAX) {
        const cur = selected.get(key);
        if (!cur) break;
        cur.quantity -= 1;
        if (cur.quantity <= 0) {
          selected.delete(key);
          break;
        }
      }

      renderAll();
    } else {
      refreshGridButtons();
    }
  }

  // ------- Submit to Cart (components only) -------
async function addKitToCart() {
    if (getSelectedNailCount() < MIN) return;
    if (root.dataset.submitting === 'true') return;
    root.dataset.submitting = 'true';

    const bundleKey =
      (window.crypto && crypto.randomUUID && crypto.randomUUID()) ||
      ('bk_' + Date.now() + '_' + Math.random().toString(16).slice(2));

    const PROMO_LAMP_IDS = new Set([
      '47478736322725', // Ultimate promo lamp variant
      '47478736486565', // Base promo lamp variant
    ]);

    const OIL_VARIANT_ID = '46009669157029';

    // Public-friendly label shown in cart
    const displayProps = {};
    displayProps[KIT_PROP_LABEL] = KIT_TITLE;

    // Private bundle metadata (used by cart-guard)
    const privateProps = {
      _bundle_key: bundleKey,
      _bundle_type: KIT_TYPE,
      _bundle_min: String(MIN),
      _bundle_expected_nails: String(MIN),
      _bundle_expected_oil: (KIT_TYPE === 'ultimate') ? '1' : '0',
      _bundle_version: '4',
    };

    const items = [];

    // Included items: lamp/oil
    included.forEach((v) => {
      const vid = String(v.id);
      const isPromoLamp = PROMO_LAMP_IDS.has(vid);
      const isOil = vid === OIL_VARIANT_ID;

      items.push({
        id: v.id,
        quantity: 1,
        properties: {
          ...displayProps,
          ...privateProps,
          _bundle_role: isPromoLamp ? 'lamp' : (isOil ? 'oil' : 'included'),
          _bundle_promo: isPromoLamp ? 'true' : 'false',
        },
      });
    });

    // Selected nails (quantity-aware)
    selected.forEach((v) => {
      items.push({
        id: v.id,
        quantity: Number(v.quantity || 1),
        properties: {
          ...displayProps,
          ...privateProps,
          _bundle_role: 'nail',
        },
      });
    });

    submitBtns.forEach((b) => b.classList.add('is-loading'));
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('Cart add failed');

      if (window.theme?.cartDrawer?.open) {
        window.theme.cartDrawer.open();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error('[Builder Kit] add failed', err);
      try {
        const checkCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cartData = await checkCart.json();
        const hasBundle = cartData.items && cartData.items.some(function(item) { return item.properties && item.properties._bundle_key; });
        if (hasBundle) {
          window.location.href = '/cart';
          return;
        }
      } catch (e) {}
      alert('Sorry, we could not add the kit to the cart. Please try again.');
} finally {
      submitBtns.forEach((b) => b.classList.remove('is-loading'));
      root.dataset.submitting = 'false';
    }
  }

  // ------- Events -------
  root.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.builder-kit__add');
    if (addBtn && root.contains(addBtn)) {
      const card = addBtn.closest('.builder-kit__card');
      if (card) toggleCard(card);
      return;
    }

    // Summary remove = decrement quantity by 1
    const removeBtn = e.target.closest('.builder-kit__remove');
    if (removeBtn && root.contains(removeBtn)) {
      const id = String(removeBtn.dataset.variant);

      const entry = selected.get(id);
      if (entry) {
        entry.quantity -= 1;
        if (entry.quantity <= 0) selected.delete(id);
        renderAll();
      }
      return;
    }

    const submitBtn = e.target.closest('.builder-kit__submit, .builder-kit__submit--mobile');
    if (submitBtn && root.contains(submitBtn)) {
      addKitToCart();
      return;
    }
  });

  root.addEventListener('change', (e) => {
    const variantSelect = e.target.closest('.builder-kit__variant');
    if (variantSelect && variantSelect.tagName === 'SELECT') {
      changeVariantOnSelectedCard(variantSelect);
    }
  });

  // ------- Bottom bar events -------
  if (bottomBar) {
    bottomBar.addEventListener('click', (e) => {
      // Remove button on bottom bar thumbnails
      const removeBtn = e.target.closest('.builder-kit__bar-item-remove');
      if (removeBtn) {
        const id = String(removeBtn.dataset.variant);
        const entry = selected.get(id);
        if (entry) {
          entry.quantity -= 1;
          if (entry.quantity <= 0) selected.delete(id);
          renderAll();
        }
        return;
      }

      // Submit button in bottom bar
      const submitBtn = e.target.closest('.builder-kit__bar-submit');
      if (submitBtn) {
        addKitToCart();
        return;
      }
    });
  }

  // micro feedback style at MAX / locked
  (function addLimitStyle() {
    const style = document.createElement('style');
    style.textContent = `
      .builder-kit__add.kit-limit, .builder-kit__variant.kit-limit { animation: kitShake .3s; }
      .builder-kit__card.is-locked { opacity: 0.92; position: relative; }
      .builder-kit__card.is-locked::after {
        content: "Included";
        position: absolute; top: 8px; right: 8px;
        background: #f1f1f1; color: #333; font-size: 12px;
        padding: 2px 6px; border-radius: 3px;
      }
      @keyframes kitShake {
        10% { transform: translateX(-2px); }
        30% { transform: translateX(2px); }
        50% { transform: translateX(-1px); }
        70% { transform: translateX(1px); }
        90% { transform: translateX(0); }
      }
    `;
    document.head.appendChild(style);
  })();
  // ------- Image Slider per Card -------
  (function initSliders() {
    root.querySelectorAll('.builder-kit__slider').forEach(function (slider) {
      const track = slider.querySelector('.builder-kit__slider-track');
      const slides = slider.querySelectorAll('.builder-kit__slide');
      const dots = slider.querySelectorAll('.builder-kit__slider-dot');
      const prevBtn = slider.querySelector('.builder-kit__slider-prev');
      const nextBtn = slider.querySelector('.builder-kit__slider-next');

      if (!track || slides.length <= 1) return;

      let current = 0;
      const total = slides.length;

      function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        current = index;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(current + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(Number(dot.dataset.slide || 0));
        });
      });

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            goTo(current + 1);
          } else {
            goTo(current - 1);
          }
        }
      }, { passive: true });
    });
  })();

  // ------- Init -------
  (async function init() {
    await hydrateIncluded();
    renderAll();
  })();
})();